<template>
  <div class="container">
    报名信息
  </div>
</template>

<script>
export default {
  name: 'ComponentName',
  components: {
    
  },
  props: {
    
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>

</style>